import { createUseStyles } from 'react-jss'

export default createUseStyles({
  fileContainer: {
    marginTop: 10
  },
  clickThroughLinkField: {
    // reset clickThroughLinkField .stepBody .field marginTop
    marginTop: [8, '!important']
  }
})
